import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import MainDispatcher from '../support/MainDispatcher';

import imageUpload from '../../main/support/imageUpload';

const DISCO_ADS_PATH = '/v1/disco-ads';

// ****************** HELPER FUCNTIONS ************************** //

const handleCampaignUpdate = (params) => {
  const { id, ...remainingParams } = params;
  return dash_api.patch(`${DISCO_ADS_PATH}/campaign/${id}`, remainingParams).then(({ data }) => data);
};

const handleAdGroupUpdate = (params) => {
  const { id, ...remainingParams } = params;
  return dash_api.patch(`${DISCO_ADS_PATH}/ad-group/${id}`, remainingParams).then(({ data }) => data);
};

// ****************** MANAGEMENT ACTIONS ************************** //

// ////////////// RETRIEVE ALL CAMPAIGNS FOR A GIVEN APP //////////////////////
const RetrieveDiscoAdsCampaigns = new ReduxAsyncAction('RETRIEVE_DISCO_ADS_CAMPAIGNS');

RetrieveDiscoAdsCampaigns.registerRequest((dateRange) => {
  const { start_date, end_date } = dateRange;
  return dash_api.get(`${DISCO_ADS_PATH}/campaigns?start_date=${start_date}&end_date=${end_date}`).then(({ data }) => data);
});
export const RETRIEVE_DISCO_ADS_CAMPAIGNS = RetrieveDiscoAdsCampaigns.constants;
export const retrieveDiscoAdsCampaigns = (dateRange) => async (dispatch) => {
  try {
    await dispatch(RetrieveDiscoAdsCampaigns.request(dateRange));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'RETRIEVE_DISCO_ADS_CAMPAIGNS_ERROR',
      error: 'Error retrieving campaigns data',
    });
  }
};

// ////////////// RETRIEVE A SINGLE CAMPAIGN FOR A GIVEN APP //////////////////////
const RetrieveSingleCampaign = new ReduxAsyncAction('RETRIEVE_SINGLE_CAMPAIGN');

RetrieveSingleCampaign.registerRequest((params) => {
  const { campaignId } = params;
  return dash_api.get(`${DISCO_ADS_PATH}/campaign/${campaignId}`).then(({ data }) => data);
});
export const RETRIEVE_SINGLE_CAMPAIGN = RetrieveSingleCampaign.constants;
export const retrieveSingleCampaign = (params) => async (dispatch) => {
  try {
    await dispatch(RetrieveSingleCampaign.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'RETRIEVE_SINGLE_CAMPAIGN_ERROR',
      error: 'Error retrieving campaign data',
    });
  }
};

// ////////////// RETRIEVE ALL AD GROUPS FOR A GIVEN CAMPAIGN //////////////////////
const RetrieveDiscoAdsAdGroups = new ReduxAsyncAction('RETRIEVE_DISCO_ADS_AD_GROUPS');
RetrieveDiscoAdsAdGroups.registerRequest(({ campaignId, dateRange }) => {
  const { start_date, end_date } = dateRange;
  return dash_api
    .get(`${DISCO_ADS_PATH}/ad_groups/${campaignId}?start_date=${start_date}&end_date=${end_date}`)
    .then(({ data }) => data);
});
export const RETRIEVE_DISCO_ADS_AD_GROUPS = RetrieveDiscoAdsAdGroups.constants;
export const retrieveDiscoAdsAdGroups = (params) => async (dispatch) => {
  try {
    await dispatch(RetrieveDiscoAdsAdGroups.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'RETRIEVE_DISCO_ADS_AD_GROUPS_ERROR',
      error: 'Error retrieving ad-groups data',
    });
  }
};

// ////////////// RETRIEVE A SINGLE AD GROUP FOR A GIVEN CAMPAIGN //////////////////////
const RetrieveSingleAdGroup = new ReduxAsyncAction('RETRIEVE_SINGLE_AD_GROUP');

RetrieveSingleAdGroup.registerRequest((params) => {
  const { adGroupId } = params;
  return dash_api.get(`${DISCO_ADS_PATH}/ad_group/${adGroupId}`).then(({ data }) => data);
});
export const RETRIEVE_SINGLE_AD_GROUP = RetrieveSingleAdGroup.constants;
export const retrieveSingleAdGroup = (params) => async (dispatch) => {
  try {
    await dispatch(RetrieveSingleAdGroup.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'RETRIEVE_SINGLE_AD_GROUP_ERROR',
      error: 'Error retrieving ad group data',
    });
  }
};

// ////////////// RETRIEVE ALL CREATIVE SETS FOR A GIVEN AD GROUP //////////////////////
const RetrieveDiscoAdsCreatives = new ReduxAsyncAction('RETRIEVE_DISCO_ADS_CREATIVES');
RetrieveDiscoAdsCreatives.registerRequest(({ adGroupId, dateRange }) => {
  const { start_date, end_date } = dateRange;
  return dash_api
    .get(`${DISCO_ADS_PATH}/creatives/${adGroupId}?start_date=${start_date}&end_date=${end_date}`)
    .then(({ data }) => data);
});
export const RETRIEVE_DISCO_ADS_CREATIVES = RetrieveDiscoAdsCreatives.constants;
export const retrieveDiscoAdsCreatives = (params) => async (dispatch) => {
  try {
    await dispatch(RetrieveDiscoAdsCreatives.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'RETRIEVE_DISCO_ADS_CREATIVES_ERROR',
      error: 'Error retrieving creatives data',
    });
  }
};

// ///////////////// UPDATE A CAMPAIGN ///////////////////////////
const UpdateDiscoAdsCampaign = new ReduxAsyncAction('UPDATE_DISCO_ADS_CAMPAIGN');

UpdateDiscoAdsCampaign.registerRequest((params) => {
  return handleCampaignUpdate(params);
});
export const UPDATE_DISCO_ADS_CAMPAIGN = UpdateDiscoAdsCampaign.constants;
export const updateDiscoAdsCampaign = (params) => async (dispatch) => {
  try {
    await dispatch(UpdateDiscoAdsCampaign.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'UPDATE_DISCO_ADS_CAMPAIGN_ERROR',
      error: `Error updating campaign data`,
    });
  }
};

// /////////////////////// UPDATE AN AD GROUP ///////////////////
const UpdateDiscoAdsAdGroup = new ReduxAsyncAction('UPDATE_DISCO_ADS_AD_GROUP');

UpdateDiscoAdsAdGroup.registerRequest((params) => {
  return handleAdGroupUpdate(params);
});
export const UPDATE_DISCO_ADS_AD_GROUP = UpdateDiscoAdsAdGroup.constants;
export const updateDiscoAdsAdGroup = (params) => async (dispatch) => {
  try {
    await dispatch(UpdateDiscoAdsAdGroup.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'UPDATE_DISCO_ADS_AD_GROUP_ERROR',
      error: `Error updating ad group data`,
    });
  }
};

// ///////////////// UPDATE A CREATIVE ///////////////////////////
const UpdateDiscoAdsCreative = new ReduxAsyncAction('UPDATE_DISCO_ADS_CREATIVE');

UpdateDiscoAdsCreative.registerRequest((params) => {
  const { id, ...remainingParams } = params;
  return dash_api.patch(`${DISCO_ADS_PATH}/creative/${id}`, remainingParams).then(({ data }) => data);
});
export const UPDATE_DISCO_ADS_CREATIVE = UpdateDiscoAdsCreative.constants;
export const updateDiscoAdsCreative = (params) => async (dispatch) => {
  try {
    await dispatch(UpdateDiscoAdsCreative.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'UPDATE_DISCO_ADS_CREATIVE_ERROR',
      error: 'Error updating creative asset',
    });
  }
};

// /////////////// UNSET CURRENT AD OBJECT /////////////////////
export const UNSET_CURRENT_AD_OBJECT = 'UNSET_CURRENT_AD_OBJECT';
export const unsetCurrentAdObject = (keys) => {
  return {
    keys,
    type: UNSET_CURRENT_AD_OBJECT,
  };
};

// /////////////// UPDATE CURRENT CAMPAIGN /////////////////////
const UpdateCurrentCampaign = new ReduxAsyncAction('UPDATE_CURRENT_CAMPAIGN');

UpdateCurrentCampaign.registerRequest((params) => {
  return handleCampaignUpdate(params);
});

export const UPDATE_CURRENT_CAMPAIGN = UpdateCurrentCampaign.constants;
export const updateCurrentCampaign = (params) => async (dispatch) => {
  try {
    await dispatch(UpdateCurrentCampaign.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'UPDATE_CURRENT_CAMPAIGN',
      error: `Error updating campaign settings data`,
    });
  }
};

// /////////////// UPDATE CURRENT AD GROUP /////////////////////
const UpdateCurrentAdGroup = new ReduxAsyncAction('UPDATE_CURRENT_AD_GROUP');

UpdateCurrentAdGroup.registerRequest((params) => {
  return handleAdGroupUpdate(params);
});
export const UPDATE_CURRENT_AD_GROUP = UpdateCurrentAdGroup.constants;
export const updateCurrentAdGroup = (params) => async (dispatch) => {
  try {
    await dispatch(UpdateCurrentAdGroup.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'UPDATE_CURRENT_AD_GROUP',
      error: `Error updating ad group settings data`,
    });
  }
};

// ****************** CREATOR FLOW ************************** //

// ///////////////// SAVE CREATOR STEP ///////////////////////////
export const SAVE_DISCO_ADS_CREATOR_STEP = 'SAVE_DISCO_ADS_CREATOR_STEP';
export const saveDiscoAdsCreatorStep = ({ stepKey, payload }) => {
  return {
    stepKey,
    payload,
    type: SAVE_DISCO_ADS_CREATOR_STEP,
  };
};

// ////////////// FETCH CAMPAIGN GEO-TARGETING SHAPES ///////////////////
const FetchGeoTargetingShapes = new ReduxAsyncAction('FETCH_GEO_TARGETING_SHAPES');

FetchGeoTargetingShapes.registerRequest((params) => {
  const { userQuery } = params;
  return dash_api.get(`${DISCO_ADS_PATH}/geo_shapes/search?prefix=${userQuery}`).then(({ data }) => data);
});
export const FETCH_GEO_TARGETING_SHAPES = FetchGeoTargetingShapes.constants;
export const fetchGeoTargetingShapes = (params) => async (dispatch) => {
  try {
    await dispatch(FetchGeoTargetingShapes.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'FETCH_GEO_TARGETING_SHAPES_ERROR',
      error: 'Error fetching geo targeting options',
    });
  }
};

// /////////////////// CREATE CAMPAIGN BATCH REQUEST //////////////////////
const CreateCampaignBatch = new ReduxAsyncAction('CREATE_CAMPAIGN_BATCH');

CreateCampaignBatch.registerRequest((params) => {
  return dash_api.post(`${DISCO_ADS_PATH}/batch/campaign`, params).then(({ data }) => data);
});

export const CREATE_CAMPAIGN_BATCH = CreateCampaignBatch.constants;
export const createCampaignBatch = (params) => async (dispatch) => {
  try {
    await dispatch(CreateCampaignBatch.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'CREATE_CAMPAIGN_BATCH_ERROR',
      error: 'Error creating new mobile promotions campaign',
    });
  }
};

// /////////////////// CREATE AD GROUP BATCH REQUEST ///////////////////////
export const CreateAdGroupBatch = new ReduxAsyncAction('CREATE_AD_GROUP_BATCH');

CreateAdGroupBatch.registerRequest((params) => {
  return dash_api.post(`${DISCO_ADS_PATH}/batch/ad-group`, params).then(({ data }) => data);
});

export const CREATE_AD_GROUP_BATCH = CreateAdGroupBatch.constants;
export const createAdGroupBatch = (params) => async (dispatch) => {
  try {
    await dispatch(CreateAdGroupBatch.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'CREATE_AD_GROUP_BATCH_ERROR',
      error: 'Error creating new ad group',
    });
  }
};

// /////////////////// CLEAR CREATOR DATA //////////////////////
export const CLEAR_DISCO_ADS_CREATOR_DATA = 'CLEAR_DISCO_ADS_CREATOR_DATA';
export const clearDiscoAdsCreatorData = () => {
  return {
    type: CLEAR_DISCO_ADS_CREATOR_DATA,
  };
};

export const CLEAR_DISCO_ADS_CREATOR_STEP = 'CLEAR_DISCO_ADS_CREATOR_STEP';
export const clearDiscoAdsCreatorStep = (stepKey) => {
  return {
    type: CLEAR_DISCO_ADS_CREATOR_STEP,
    stepKey,
  };
};

// /////////////////// UPLOAD CREATIVE ASSET ///////////////////////
const UploadDiscoAdsCreative = new ReduxAsyncAction('UPLOAD_DISCO_ADS_CREATIVE');

UploadDiscoAdsCreative.registerRequest(({ imageFile }) => {
  return imageUpload('/v1/image', { directory: 'disco-ads-creator' }, { icon: imageFile }).then((imageUrl) => imageUrl);
});

export const UPLOAD_DISCO_ADS_CREATIVE = UploadDiscoAdsCreative.constants;
export const uploadDiscoAdsCreative = (params) => async (dispatch) => {
  try {
    await dispatch(UploadDiscoAdsCreative.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'UPLOAD_DISCO_ADS_CREATIVE_ERROR',
      error: 'Error while uploading creative asset',
    });
  }
};

// /////////////////// CLEAR CREATIVE IMAGE URL //////////////////////////////
export const CLEAR_CREATIVE_IMAGE_URL = 'CLEAR_CREATIVE_IMAGE_URL';
export const clearCreativeImageUrl = () => {
  return {
    type: CLEAR_CREATIVE_IMAGE_URL,
  };
};

// /////////////// GENERATE a STAND-ALONE CREATIVE SET /////////////////

export const GenerateCreative = new ReduxAsyncAction('GENERATE_CREATIVE');

GenerateCreative.registerRequest((params) => {
  return dash_api.post(`${DISCO_ADS_PATH}/creative`, params).then(({ data }) => data);
});

export const GENERATE_CREATIVE = GenerateCreative.constants;
export const generateCreative = (params) => async (dispatch) => {
  try {
    await dispatch(GenerateCreative.request(params));
  } catch (e) {
    MainDispatcher.dispatch({
      action: 'GENERATE_CREATIVE_ERROR',
      error: 'Error creating the Discovery Ads creative set',
    });
  }
};
